import { BackgroundJobDetailPage } from "@/features/background-job/pages/BackgroundJobDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/background-job/transaction/$id/detail",
)({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["background_job.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: BackgroundJobDetailPage,
});
